export const ADD_ACTIVITY_TYPE = 'ADD_ACTIVITY_TYPE';
export const ADD_CERTIFICATE_LIST = 'ADD_CERTIFICATE_LIST';

export const addActivityType = (value) => ({
    type: ADD_ACTIVITY_TYPE,
    payload: value
});

export const addCertificateList = (value) => ({
    type: ADD_CERTIFICATE_LIST,
    payload: value
});
